import { Component } from '@angular/core';
import { UserService } from '../../../resources/user/user.service';

@Component({
  selector: 'app-top-navigation',
  templateUrl: './top-navigation.component.html',
  styleUrls: ['./top-navigation.component.scss']
})
export class TopNavigationComponent {
  constructor(private userService: UserService) {}

  logout() {
    this.userService.logout();
  }
}



// WEBPACK FOOTER //
// C:/projektyWeb/McComp_Flota/Front/src/app/pages/shared/top-navigation/top-navigation.component.ts